import { useState, useEffect } from 'react'
import { Modal } from '@mui/material'
import styles from './Notices.module.scss'
import SanitizeHtml from '../Base/SanitizeHtml/SanitizeHtml'

const ImportantNoticesMobile = () => {
  const { title, number, records } = window.noticeData
  const [isOpen, setIsOpen] = useState(false)

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      <div className={styles.notice__block}>
        <div className={styles.notice__main__and__secondary}>
          <div className={styles.main__block}>
            <div className={styles.number}>
              <span>{records.length}</span>
            </div>
            <button
              className={`btn ${styles.btn}`}
              type="button"
              id="ImportantNoticesMobile"
              onClick={handleOpen}
              aria-label="Open important notices">
              {title}
              <i className={`icon-arrow-down arrow ${styles.arrow}`} />
            </button>
          </div>
        </div>
      </div>

      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="important-notices-modal-title"
        aria-describedby="important-notices-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <div className={styles.notice__modal}>
          <div className={styles.notice__modal__header}>
            <h2
              id="important-notices-modal-title"
              className={styles.modal__title}>
              {title}
            </h2>
            <button
              type="button"
              className="btn-clear"
              onClick={handleClose}
              aria-label="Close important notices">
              <i className="icon icon-x"></i>
            </button>
          </div>
          <div className={styles.notice__modal__body}>
            <article className="b-article">
              {records.map((record, index) => (
                <div key={index} className={styles.noteCard}>
                  <i
                    className="icon-info"
                    style={{ fontSize: '20px', marginRight: '15px' }}></i>
                  <SanitizeHtml html={record.text} />
                </div>
              ))}
            </article>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ImportantNoticesMobile
